import { cn } from "@/lib/utils";
import type { ChatMessage } from "@/types";
import { CheckCheck, AlertTriangle } from "lucide-react";
import ReactMarkdown from "react-markdown";

// Custom components for HAPI-styled markdown
const HapiH1 = ({ node, ...props }: { node?: any; [key: string]: any }) => (
  <h1 style={{ color: "#da7756" }} {...props} />
);

interface MessageBubbleProps {
  message: ChatMessage;
}

export const MessageBubble = ({ message }: MessageBubbleProps) => {
  const isUser = message.author === "user";
  const bubbleClasses = cn(
    isUser
      ? "max-w-[90%] sm:max-w-[85%] rounded-xl sm:rounded-2xl px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm shadow-sm transition-all bg-gradient-to-br from-primary/10 to-white/5 text-primary ml-auto backdrop-blur-sm"
      : "w-full sm:max-w-[95%] rounded-xl sm:rounded-2xl px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm shadow-sm transition-all glass-card text-foreground border border-accent/10 shadow backdrop-blur-md bg-gradient-to-br from-white/10 to-white/5",
  );

  const statusIcon =
    message.status === "error" ? (
      <AlertTriangle className="h-3.5 w-3.5 text-rose-500" />
    ) : (
      <CheckCheck className="h-3.5 w-3.5 text-white/80" />
    );

  return (
    <div className={cn("flex flex-col gap-1", isUser ? "items-end" : "items-start")} data-testid={`message-${message.id}`}>
      <div className={bubbleClasses}>
        <ReactMarkdown components={{h1: HapiH1}} data-testid={`message-content-${message.id}`}>
          {message.content || "…"}
        </ReactMarkdown>
        {/* <p className="leading-relaxed break-words" data-testid={`message-content-${message.id}`}>{message.content || "…"}</p> */}
        {message.tags && message.tags.length ? (
          <div className="mt-1.5 sm:mt-2 flex flex-wrap gap-1 sm:gap-2">
            {message.tags.map(tag => (
              <span key={tag} className="pill bg-white/20 text-[10px] sm:text-xs text-white">
                #{tag}
              </span>
            ))}
          </div>
        ) : null}
      </div>
      <div className="flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-[11px] text-muted-foreground">
        <span>{new Date(message.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
        {message.status === "sent" && <span className="rounded-full bg-emerald-50 px-1.5 py-0.5 text-[9px] sm:text-[10px] text-emerald-700">Synced</span>}
        {message.status === "streaming" && <span className="rounded-full bg-primary/10 px-1.5 py-0.5 text-[9px] sm:text-[10px] text-primary">Streaming</span>}
        {message.status === "error" && <span className="rounded-full bg-rose-50 px-1.5 py-0.5 text-[9px] sm:text-[10px] text-rose-700">Error</span>}
        {isUser ? statusIcon : null}
      </div>
    </div>
  );
};
